<template>
    <div class="NewReportGCCLeftFilterBar panel panel-default margin-top-15px">
      <div class="container-fluid courseEnrollmentPannel">
        <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-15px padding-bottom-15px" data-toggle="collapse" data-target="#demo"> -->
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-15px padding-bottom-15px">
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 padding-left-0px padding-right-0px">
            <span class="glyphicon glyphicon-ok cursor-pointer" :class="{'opacity-point-3 cursor-default' : getCohortListValue.length === 0, 'green-tick': hasSelectedCurrGroupCourse}" @click="performUserAction('tick_clicked')"></span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 word-break padding-right-0px">
            <span class="cursor-pointer">{{getCurrGccObjValue.CourseTitle + ' [' + getCurrGccObjValue.CourseSubTitle + ']'}} </span>
          </div>
          <div class="col-lg-2 col-md-2 col-md-2 col-xs-2">
            <span class="glyphicon cursor-pointer" :class="{'glyphicon-triangle-bottom' : showCohortList, 'glyphicon-triangle-top' : !showCohortList, 'opacity-point-3 cursor-default' : getCohortListValue.length === 0}" @click="showHideCohortList"></span>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-0px padding-bottom-15px padding-left-0px padding-right-0px">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-left-0px cursor-pointer">
            <b>{{totalAvailableCohorts + (totalAvailableCohorts > 1 ? ' Cohorts' : ' Cohort')}} - {{totalPresentParticipants + (totalPresentParticipants > 1 ? ' Enrollments' : ' Enrollment')}}</b>
          </div>
        </div>
      </div>
      <!-- <div class="container-fluid cohortEnrollmentPannel collapse" id="demo"> -->
      <div class="container-fluid cohortEnrollmentPannel" v-if="showCohortList">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 border-color-hash-ddd padding-top-15px padding-bottom-15px padding-left-0px padding-right-0px">
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-left-0px padding-right-0px">
            <button type="button" class="btn black-border custom-btn white-BG btn-sm" @click="performUserAction('clear_all')">
              Clear All
            </button>
            <button type="button" class="btn black-border custom-btn white-BG btn-sm" @click="performUserAction('select_all')">
              Select All
            </button>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1"></div>
        </div>
        <cohort-list v-for="currCohortObj in getCohortListValue" :key="currCohortObj.CohortId" :currGccObj="getCurrGccObjValue" :selectedGroupObj="selectedGroupObj" :gccList="gccList" :currCohortObj="currCohortObj" :cohortList="getCohortListValue"></cohort-list>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div>    
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import { constants } from '@/utils/constants'
import { forEach, findIndex } from 'lodash'
import CohortList from '@/components/new_report/CohortList'
export default {
  props: ['currGccObj', 'selectedGroupObj', 'gccList'],
  created: function () {
    this.computeCohortAndParticipantCount()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      showCohortList: false,
      totalAvailableCohorts: 0,
      totalPresentParticipants: 0,
      hasSelectedCurrGroupCourse: false
    }
  },
  methods: {
    performUserAction: function (operationName) {
      if (this.getCohortListValue.length > 0) {
        if (operationName === 'tick_clicked') {
          this.hasSelectedCurrGroupCourse = !this.hasSelectedCurrGroupCourse
          operationName = this.hasSelectedCurrGroupCourse ? 'select_all' : 'clear_all'
        }
        switch (operationName) {
          case 'select_all':
            forEach(this.getCohortListValue, (cohortObj) => {
              if (this.getSelectedCohortIds.indexOf(cohortObj.CohortId) === -1) {
                this.$store.state.selectedCohortIds.push(cohortObj.CohortId)
                console.log('Added as Not present: ' + cohortObj.CohortName)
              } else {
                console.log('Ignored as already present: ' + cohortObj.CohortName)
              }
            })
            break
          case 'clear_all':
            forEach(this.getCohortListValue, (cohortObj) => {
              const foundIndex = findIndex(this.getSelectedCohortIds, (cohortId) => {
                return cohortObj.CohortId === cohortId
              })
              if (foundIndex > -1) {
                this.$store.state.selectedCohortIds.splice(foundIndex, 1)
                console.log('Found at Position: ' + foundIndex)
              } else {
                console.log('Not found in selection list: ' + cohortObj.CohortName)
              }
            })
            break
        }
        console.log('this.$store.state.selectedCohortIds' + this.$store.state.selectedCohortIds.length)
      }
    },
    showHideCohortList: function () {
      if (this.getCohortListValue.length > 0) {
        this.showCohortList = !this.showCohortList
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    computeCohortAndParticipantCount: function () {
      this.totalAvailableCohorts = this.getCohortListValue.length
      this.totalPresentParticipants = 0
      forEach(this.getCohortListValue, (cohortObj) => {
        this.totalPresentParticipants += cohortObj.DashboardDataList.length
      })
    },
    checkAndUpdateHasSelectedCurrGroupCourse: function () {
      var totalFoundCount = 0
      forEach(this.$store.state.selectedCohortIds, (cohortId) => {
        forEach(this.getCohortListValue, (cohortObj) => {
          if (cohortObj.CohortId === cohortId) {
            totalFoundCount += 1
          }
        })
      })
      console.log('this.getCohortListValue.length > 0 && this.getCohortListValue.length === totalFoundCount: ' + (this.getCohortListValue.length > 0 && this.getCohortListValue.length === totalFoundCount))
      this.hasSelectedCurrGroupCourse = this.getCohortListValue.length > 0 && this.getCohortListValue.length === totalFoundCount
    }
  },
  components: {
    'alert-box': AlertBox,
    'cohort-list': CohortList
  },
  computed: {
    getSelectedCohortIds: {
      get: function () {
        return this.$store.state.selectedCohortIds
      },
      set: function (newValue) {
        this.$store.state.selectedCohortIds = newValue
      }
    },
    getCurrGccObjValue: {
      get: function () {
        return this.currGccObj
      }
    },
    getSelectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getGccListValue: {
      get: function () {
        return this.gccList
      }
    },
    getCohortListValue: {
      get: function () {
        return this.getCurrGccObjValue.CohortProgressDataList
      }
    }
  },
  watch: {
    getSelectedCohortIds: function (newValue, oldValue) {
      console.log('CourseList File::')
      this.checkAndUpdateHasSelectedCurrGroupCourse()
    }
  },
  name: 'NewReportGCCLeftFilterBar'
}
</script>

<style scoped>
.green-tick {
  color: green !important;
}
.cursor-default {
  cursor: default !important;
}
.opacity-point-3 {
  opacity: 0.3;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #fff;
}
.word-break {
  word-break: break-word;
}
.cursor-pointer {
  cursor: pointer;
}
.padding-top-15px {
  padding-top: 15px;
}
.padding-bottom-15px {
  padding-bottom: 15px;
}
.black-border {
  border: 1px solid #aaa;
}
.border-bottom-0px {
  border-bottom: 0px;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.border-top-0px {
  border-top: 0px;
}
.courseEnrollmentPannel {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
  /* margin-top: 15px; */
  padding-left: 0px;
  padding-right: 0px;
}
.cohortEnrollmentPannel {
  color: #333;
  background-color: #fff;
  border-color: #ddd;
  padding-left: 0px;
  padding-right: 0px;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-left-15px {
  padding-left: 15px;
}
.margin-top-15px {
  margin-top: 15px;
}
.panel-default {
  border-color: #ddd;
}
.border-hash-ddd {
  border-color: 1px solid #ddd;
}
.border-top-ddd {
  border-top:1px solid #ddd;
} 
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/new_report/CourseList.vue